module.exports = __webpack_public_path__ + "img/3LNG_Cover.6eab800a.jpg";